import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { formatNumbers, newFormatPrice } from '../../../../services/utilityFunctions';

function Deviation({ deviation, deviationTarget, generalTitle, titleDeviation, titleTarget, targetObj = {}, unityType }) {
  const { points, target, unity, currency } = targetObj;
  const infoUnity = unityType;

  // Values to Percentage so it can be use in progress-bar
  let pointsPercentage = (100 * points) / target;
  if (points < 0) { // force deviation bar to be empty when points are ZERO
    pointsPercentage = 0;
  }
  const deviationPercentage = (100 * deviationTarget) / target;

  // format value either currency, either other type of unity
  const valueToUse = (type, number) => type === 'currency' ?
    newFormatPrice(number, false, currency || 'eur') : `${formatNumbers(number)} ${infoUnity}`;

  let deviationNumber = 0;
  if (deviation) {
    deviationNumber = valueToUse(unity, deviation);
  }
  return (
    <div className="deviation-container">
      <h4 className="deviation-title">{generalTitle}</h4>
      <div className="row deviation-progress">
        <div className="col-lg-9 col-9">
          <div className="progress-mark">
            <div className="progress-mark-values row">
              <div className="progress-mark-bar col-lg-12 col-12 progress-no-padding">
                <span style={{ width: `${pointsPercentage > 100 ? 100 : pointsPercentage}%` }} />
              </div>
              <div
                className="progress-bar-mark col-lg-12 col-12"
                style={{ maxWidth: `${deviationPercentage > 100 ? 100 : deviationPercentage}%` }}
              >
                <span />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`col-lg-3 col-3 deviation-progress-value no-wrap-value ${
          deviation < 0 ?
            'negative-deviation-value' : 'positive-deviation-value'
          }`}
        >
          {valueToUse(unity, points)}
        </div>
      </div>
      <div className="row deviation-target">
        <div className="col-lg-9 col-9">{titleTarget}</div>
        <div className="col-lg-3 col-3 deviation-target-value no-wrap-value">
          {valueToUse(unity, target)}
        </div>
      </div>
      <div className="row deviation-deviation">
        <div className="col-lg-9 col-9">{titleDeviation}</div>
        <div
          className={`col-lg-3 col-3 deviation-deviation-value no-wrap-value ${
          deviation < 0 ?
            'negative-deviation-value' : 'positive-deviation-value'
          }`}
        >
          {deviationNumber}
        </div>
      </div>
    </div>
  );
}

Deviation.propTypes = {
  deviation: PropTypes.number.isRequired,
  deviationTarget: PropTypes.number.isRequired,
  titleDeviation: PropTypes.string.isRequired,
  titleTarget: PropTypes.string.isRequired,
  generalTitle: PropTypes.string.isRequired,
  targetObj: PropTypes.shape({
    points: PropTypes.number,
    progress: PropTypes.number,
    target: PropTypes.number,
    unity: PropTypes.string,
    currency: PropTypes.string,
  }),
  unityType: PropTypes.string.isRequired,
};

Deviation.defaultProps = {
  targetObj: {
    target: 0,
    progress: 0,
    points: 0,
  },
};

export default translate(Deviation);
